import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "antd";
import SlideoutMenu from "components/atoms/SlideoutMenu";
import DataObjectShareOption from "containers/DataObjectShareOption";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface IDuplicateDataObjectListActionButtonsProps {
    dataObjectId: string;
    dataSetId: string;
    schemaId: string;
    businessAreaId: string;
    selected?: boolean;
    children?: React.ReactNode;
}

export default function DuplicateDataObjectListActionButtons({
    dataObjectId,
    dataSetId,
    schemaId,
    businessAreaId,
    selected = false,
    children,
}: IDuplicateDataObjectListActionButtonsProps) {
    return (
        <SlideoutMenu>
            <DataObjectShareOption
                dataTestid={CypressTestIds.DUPLICATE_DATAOBJECT_SHARE_BUTTON}
                size="middle"
                dataObjectId={dataObjectId}
                dataSetId={dataSetId}
                schemaId={schemaId}
                businessAreaId={businessAreaId}
            ></DataObjectShareOption>
            <Tooltip title="View Record in New Tab">
                <Button
                    type="link"
                    icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
                    href={`${window.location.origin}/${dataObjectId}`}
                    target="_blank"
                    data-testid={CypressTestIds.DUPLICATE_DATAOBJECT_VIEW_BUTTON}
                    onClick={(e) => {
                        e && e.stopPropagation && e.stopPropagation();
                    }}
                />
            </Tooltip>
            {children}
        </SlideoutMenu>
    );
}
